import { render, staticRenderFns } from "./UserChangePassword.vue?vue&type=template&id=8b639446&scoped=true&"
import script from "./UserChangePassword.vue?vue&type=script&lang=ts&"
export * from "./UserChangePassword.vue?vue&type=script&lang=ts&"
import style0 from "./UserChangePassword.vue?vue&type=style&index=0&id=8b639446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b639446",
  null
  
)

export default component.exports